import { useState, useEffect } from 'react'

/**
 * useFastMount is a hook designed to eliminate React Router navigation freezing
 * when rendering heavily populated pages.
 * 
 * It returns `false` during the initial synchronous render pass. This allows 
 * components to render a heavily truncated list (e.g. 5 items instead of 50)
 * ensuring that the navigation transition takes < 5ms.
 * 
 * Immediately after the initial paint, it flips to `true`, triggering a 
 * re-render of the full component tree.
 */
export function useFastMount() {
    const [isMounted, setIsMounted] = useState(false)

    useEffect(() => {
        // requestAnimationFrame guarantees that we wait for the browser to paint
        // the initial fast-render before we clog the main thread with the heavy render.
        const frame = requestAnimationFrame(() => {
            setIsMounted(true)
        })
        return () => cancelAnimationFrame(frame)
    }, [])

    return isMounted
}
